import { getMappedLanguage } from 'i18n/helpers';
import { GetCategoriesParameters } from 'core_main/sdk/get_categories/types';
import {
  CATEGORIES_ENDPOINT,
  CATEGORY_ENDPOINT,
  ROOT_CATEGORY_ENDPOINT,
} from './constants';
import {
  FetchCategoriesParameters,
  FetchCategoryByIdParameters,
} from './types';

export const validateFetchCategoryByIdParameters = (
  parameters: FetchCategoryByIdParameters,
) => {
  const categoryId = parameters?.categoryId;
  const lang = parameters?.lang;

  if (!categoryId || !lang) {
    return new Error(
      'Missing one or more of the required properties: lang, categoryId',
    );
  }
  return undefined;
};

export const validateFetchCategoriesParameters = (
  parameters: FetchCategoriesParameters,
) => {
  const lang = parameters?.lang;

  if (!lang) {
    return new Error('Missing one or more of the required properties: lang');
  }
  return undefined;
};

export const makeGetCategoriesEndpoint = (
  parameters: FetchCategoriesParameters,
) => {
  const page = parameters?.page;
  const lang = parameters?.lang;
  const knowledgeBaseId = parameters?.knowledgeBaseId;

  const mappedLang = getMappedLanguage(lang);

  let endpoint = `/p/v4/kb/categories?pageSize=1000&page=${page}`;

  if (mappedLang) {
    endpoint = `${endpoint}&lang=${mappedLang}`;
  }

  if (knowledgeBaseId) {
    endpoint = `${endpoint}&knowledgeBaseId=${knowledgeBaseId}`;
  }

  return endpoint as typeof CATEGORIES_ENDPOINT;
};

export const makeGetCategoryEndpoint = (
  parameters: FetchCategoryByIdParameters,
  childrenLimit = 100,
) => {
  const { categoryId, lang, knowledgeBaseId } = parameters;

  const mappedLang = getMappedLanguage(lang);

  let endpoint = `/p/v4/kb/categories/${categoryId}?includeChildren=true&childrenLimit=${childrenLimit}`;

  if (mappedLang) {
    endpoint = `${endpoint}&lang=${mappedLang}`;
  }

  if (knowledgeBaseId) {
    endpoint = `${endpoint}&knowledgeBaseId=${knowledgeBaseId}`;
  }

  return endpoint as typeof CATEGORY_ENDPOINT;
};

export const makeGetRootCategoryEndpoint = (
  parameters: GetCategoriesParameters,
) => {
  if (parameters?.knowledgeBaseId) {
    return `/p/v4/kb/categories/root?knowledgeBaseId=${parameters?.knowledgeBaseId}` as typeof ROOT_CATEGORY_ENDPOINT;
  }

  return '/p/v4/kb/categories/root' as typeof ROOT_CATEGORY_ENDPOINT;
};
